module.exports = __webpack_public_path__ + "static/media/cross_gray.c05ac840.svg";